import React from 'react';
import styled from 'styled-components';
import Colors from './Colors';
import PriceDisplay from './PriceDisplay';

interface DiscountedPriceDisplayProps {
  originalPrice?: string | number;
  price: string | number;
}

const DiscountedPriceDisplay: React.FC<DiscountedPriceDisplayProps> = ({ originalPrice, price }) => {
  const shouldShowOriginalPrice = originalPrice && originalPrice !== price;

  return (
    <Wrapper>
      {shouldShowOriginalPrice ? <PriceDisplay price={originalPrice} isFaded isStriked /> : null}
      <PriceDisplay price={price} color={shouldShowOriginalPrice ? Colors.lilac : undefined} />
    </Wrapper>
  );
};

export default DiscountedPriceDisplay;

const Wrapper = styled.div`
  display: flex;
  gap: 4px;
`;
